module.exports = __webpack_public_path__ + "img/inge-v6-8.6552922c.png";